import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Spinner } from "@themesberg/react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
export default function TransaksiForm() {
    const { id } = useParams();
    const history = useHistory();
    const location = useLocation();
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Sesi kamu telah berakhir, silakan login kembali.");
            history.push("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);

            if (decoded.exp * 1000 < Date.now()) {
                localStorage.removeItem("token");
                alert("Token kamu sudah kedaluwarsa, silakan login ulang.");
                history.push("/login");
                return;
            }

            setUserRole(decoded.role);
            setTransaksi((prev) => ({
                ...prev,
                id_user: decoded.id || decoded.userId,
            }));
        } catch (err) {
            console.error("Token invalid:", err);
            localStorage.removeItem("token");
            history.push("/login");
        }
    }, [history]);

    const [mode, setMode] = useState("add");
    const [transaksi, setTransaksi] = useState({
        id_produk: 0,
        id_user: 0,
        quantity: 0,
        harga: 0,
        total: 0,
    });
    const [produkList, setProdukList] = useState([]); // 🔹 daftar produk dari API
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");
    // Ambil data produk untuk combobox
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/produk`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setProdukList(data))
            .catch((err) => console.error("Gagal ambil daftar produk:", err));
    }, []);

    // Jika edit/view mode, ambil data transaksi
    useEffect(() => {
        if (id) {
            setLoading(true);
            setMode(location.pathname.includes("edit") ? "edit" : "view");

            fetch(`${process.env.REACT_APP_API_URL}/transaksi-detail/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((res) => res.json())
                .then((data) => setTransaksi(data))
                .catch((err) => console.error("Gagal ambil detail transaksi:", err))
                .finally(() => setLoading(false));
        } else {
            setMode("add");
        }
    }, [id, location.pathname]);

    useEffect(() => {
        if (!transaksi.id_produk) return;
        if (produkList.length === 0) return;

        const selectedProduk = produkList.find((p) => p.id === transaksi.id_produk);
        if (!selectedProduk) return;

        setTransaksi((prev) => {
            const harga = Number(prev.harga) || Number(selectedProduk.harga) || 0;
            const qty = Number(prev.quantity) || 0;

            return {
                ...prev,
                harga: harga,
                total: harga * qty,
            };
        });
    }, [transaksi.id_produk, produkList]);


    const handleProdukChange = (e) => {
        const selectedID = Number(e.target.value);
        const selectedProduk = produkList.find((p) => p.id === selectedID);
        const decoded = jwtDecode(token);

        if (!selectedProduk) return;

        let harga = 0;

        if (decoded.role === "stokis") harga = selectedProduk.harga_stokis;
        else if (decoded.role === "reseller") harga = selectedProduk.harga_reseller;
        else if (decoded.role === "agen") harga = selectedProduk.harga_agen;
        else harga = selectedProduk.harga; // default

        harga = Number(harga);

        setTransaksi((prev) => ({
            ...prev,
            id_produk: selectedID,
            harga: harga,
            total: harga * (prev.quantity || 0),
        }));
    };



    const handleQuantityChange = (e) => {
        const quantity = parseInt(e.target.value) || 0;
        setTransaksi((prev) => ({
            ...prev,
            quantity,
            total: prev.harga * quantity,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = id ? "PUT" : "POST";
        const url = id
            ? `${process.env.REACT_APP_API_URL}/transaksi/${id}`
            : `${process.env.REACT_APP_API_URL}/transaksi`;

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },

                body: JSON.stringify(transaksi),
            });

            if (response.ok) {
                alert(id ? "Transaksi berhasil diperbarui ✅" : "Transaksi berhasil ditambahkan ✅");
                history.push("/transaksi");
            } else {
                alert("Terjadi kesalahan saat menyimpan transaksi ❌");
            }
        } catch (err) {
            console.error("Gagal menyimpan transaksi:", err);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <Card border="light" className="bg-white shadow-sm mb-4">
            <Card.Body>
                <h5 className="mb-4">
                    {mode === "add"
                        ? "Tambah Transaksi"
                        : mode === "view"
                            ? "Detail Transaksi"
                            : "Edit Transaksi"}
                </h5>

                <Form onSubmit={handleSubmit}>
                    {/* Pilih Produk */}
                    <Row>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>Nama Produk</Form.Label>
                                <Form.Select
                                    name="id_produk"
                                    value={transaksi.id_produk}
                                    onChange={handleProdukChange}
                                    disabled={mode === "view"}
                                    required
                                >
                                    <option value="">-- Pilih Produk --</option>
                                    {produkList.map((p) => (
                                        <option key={p.id} value={p.id}>
                                            {p.nama}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Quantity */}
                    <Row>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>Quantity</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="quantity"
                                    value={transaksi.quantity}
                                    placeholder="Masukkan jumlah"
                                    onChange={handleQuantityChange}
                                    disabled={mode === "view"}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Harga */}
                    <Row>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>Harga</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={transaksi.harga}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Total */}
                    <Row>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>Total</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={
                                        isNaN(transaksi.total)
                                            ? ""
                                            : transaksi.total.toLocaleString("id-ID")
                                    }
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Tombol */}
                    {mode === "view" ? (
                        <div className="mt-3 text-end">
                            <Button variant="secondary" onClick={() => history.push("/transaksi")}>
                                Kembali
                            </Button>
                        </div>
                    ) : (
                        <div className="mt-3 text-end">
                            <Button variant="primary" type="submit">
                                {id ? "Update" : "Simpan"}
                            </Button>{" "}
                            <Button variant="secondary" onClick={() => history.push("/transaksi")}>
                                Batal
                            </Button>
                        </div>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
}
